module.exports = __webpack_public_path__ + "static/media/Jigglypuff_gaussian2.2d3502ce.png";